export const ALLOW_CASINO = true;
